// DatePickerFromTo.jsx
'use client';

import React, { useCallback } from 'react';
import SmartDateRangeField from '../../DatePickers/SmartDateRangeField';

export default function DatePickerFromTo({
  setCheckInDate,
  setCheckOutDate,
  checkInDate,
  checkOutDate,
}) {
  const rangeValue = [
    checkInDate ? String(checkInDate) : '',
    checkOutDate ? String(checkOutDate) : '',
  ];

  const handleRangeChange = useCallback(
    ([start, end]) => {
      setCheckInDate(start || '');
      setCheckOutDate(end || '');
    },
    [setCheckInDate, setCheckOutDate]
  );

  return (
    <div className="input-style">
      <div className="d-flex justify-between px-10">
        <label style={{ fontSize: 10, fontWeight: 'normal' }}>Check-In</label>
        <label style={{ fontSize: 10, fontWeight: 'normal' }}>Check-Out</label>
      </div>

      <SmartDateRangeField
        type="date"
        value={rangeValue}               // ['YYYY-MM-DD','YYYY-MM-DD'] or ['', '']
        setValue={handleRangeChange}     // returns same shape
        placeholder="Check-in — Check-out"
        showHint={false}
        editable={false}                 // prevent manual typing (rsuite prop)
        cleanable={false}                // hide clear button
        sx={{ fontSize: 14 }}
      // minDate={new Date().toISOString().slice(0,10)} // uncomment to block past dates (today allowed)
      // container={() => document.body}                // uncomment if popup is clipped by overflow
      />
    </div>
  );
}
